import { TypographyVariant } from 'src/customizations/themes/10-parts/typography';
export function getFilterSelectFormControlSx() {
    return {
        m: 0,
        minWidth: 'auto',
        display: 'inline-flex',
        verticalAlign: 'middle',
    };
}
export function getFilterSelectMenuProps(theme) {
    return {
        disableScrollLock: true,
        anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
        transformOrigin: { vertical: 'top', horizontal: 'left' },
        PaperProps: {
            sx: {
                bgcolor: theme.palette.background.subtle,
                color: theme.palette.typography.primary,
                mt: 0.5,
            },
        },
    };
}
export function getFilterSelectChipSx(theme, { isSelected }) {
    const borderColor = isSelected
        ? theme.palette.primary.dark
        : theme.palette.border.main;
    const backgroundColor = isSelected
        ? theme.palette.primary.lightest
        : theme.palette.background.main;
    const chipRadius = theme.pressableSize.sm / 2;
    return {
        boxSizing: 'border-box',
        width: 'max-content',
        maxWidth: 'none',
        height: theme.pressableSize.sm,
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor,
        backgroundColor,
        borderRadius: `${chipRadius}px`,
        color: theme.palette.typography.primary,
        fontFamily: "'Montserrat', sans-serif",
        fontSize: theme.typography[TypographyVariant.BODY].style.fontSize,
        lineHeight: theme.typography[TypographyVariant.BODY].style.lineHeight,
        letterSpacing: 0.5,
        '& .MuiSelect-select': {
            boxSizing: 'border-box',
            display: 'flex',
            alignItems: 'center',
            width: 'auto !important',
            minWidth: `${theme.pressableSize.sm}px`,
            minHeight: `${theme.pressableSize.sm - 2}px`,
            py: `${theme.spacing.standard.xxs}px`,
            px: `${theme.spacing.standard.sm}px`,
            pr: `${theme.spacing.standard.sm}px !important`,
        },
        '& .MuiSelect-icon': {
            display: 'none',
        },
        '&::before, &::after': {
            display: 'none',
        },
        '&:hover': {
            borderColor: isSelected
                ? theme.palette.primary.dark
                : theme.palette.border.main,
        },
        '&.Mui-focused': {
            borderColor: theme.palette.primary.dark,
        },
    };
}
